import React from 'react'
import Header from '../../../component/layout/header'
import { Outlet } from 'react-router'
import useNav from '../../../component/custom-hooks/get-nav'

const ElectricBillOrgLayout = () => {
  const navList = useNav();
  let { ElectricOrgBottom, ElectricTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={ElectricOrgBottom} topTabs={ElectricTopHeader} />
      <Outlet />
    </div>
  )
}

export default ElectricBillOrgLayout